






































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import InvoicePaymentLinkService from '@/domain/billing/service/invoice-payment-link.service';
import InvoicePaymentCountry from '@/domain/billing/entity/invoice-payment-link/invoice-payment-country';
import InvoicePaymentLink from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link';
import InvoicePaymentMethod from '@/domain/billing/entity/invoice-payment-link/invoice-payment-method';
import InvoicePaymentLinkResponse from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link-response';
import InvoicePaymentLinkItem from '@/domain/billing/entity/invoice-payment-link/invoice-payment-link-item';
import Rules from '@/shared/rules/rules';
import PaymentCountrySelection from './payment-link-country-selection.component.vue';
import PaymentMethodSelection from './payment-method-selection.component.vue';

@Component({ components: { PaymentCountrySelection, PaymentMethodSelection } })
export default class BillingInfoContentPaymentLink extends Vue {
  @Prop({ type: Boolean, default: false })
  value!: boolean;

  @Prop({ type: String, required: true })
  invoiceId!: string;

  loadingCountries: boolean = false;

  countries: InvoicePaymentCountry[] = [];

  loadingPaymentMethods: boolean = false;

  paymentMethods: InvoicePaymentMethod[] = [];

  paymentLink: InvoicePaymentLink = new InvoicePaymentLink();

  validationsRules: Rules = new Rules();

  loadingLinkCreation: boolean = false;

  inputDialog(value: boolean): void {
    this.$emit('input', value)
  }

  inputCountry(countryCode: string): void {
    this.paymentLink.country = countryCode;
    this.paymentLink.paymentMethod = undefined;
    this.paymentLink.paymentMethodFlow = '';
    const { paymentMethod }: any = this.$refs;
    paymentMethod.resetValidation();

    this.loadPaymentMethods(countryCode);
  }

  inputPaymentMethod(paymentMethod: InvoicePaymentMethod): void {
    this.paymentLink.paymentMethod = paymentMethod;
    this.paymentLink.paymentMethodFlow = '';
  }

  get paymentFlows(): string[] {
    if (!this.paymentLink.paymentMethod) return [];
    return this.paymentLink.paymentMethod.allowedFlows;
  }

  copyLinkToClipboard(link: string): void {
    navigator.clipboard.writeText(link).then(() => {
      this.$emit('showSnackbar');
    });
  }

  generateLink(): void {
    const { form }: any = this.$refs;
    if (!form.validate()) return;

    this.loadingLinkCreation = true;
    InvoicePaymentLinkService.createPaymentLink(this.invoiceId, this.paymentLink)
      .then((response: InvoicePaymentLinkResponse) => {
        const link = new InvoicePaymentLinkItem({
          id: (Math.random() + 1).toString(36).substring(7),
          link: response.redirectUrl,
          createdBy: 'Você',
          createdDate: response.createdDate,
        });
        this.$emit('createdLink', link);
        this.copyLinkToClipboard(response.redirectUrl);
        this.inputDialog(false);
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingLinkCreation = false);
  }

  loadPaymentMethods(countryCode: string): void {
    if (!countryCode) return;
    this.loadingPaymentMethods = true;
    InvoicePaymentLinkService.getPaymentMethods(countryCode)
      .then((paymentMethods: InvoicePaymentMethod[]) => {
        this.paymentMethods = paymentMethods;
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingPaymentMethods = false);
  }

  created(): void {
    this.loadingCountries = true;
    InvoicePaymentLinkService.getPaymentCountries()
      .then((countries: InvoicePaymentCountry[]) => {
        this.countries = countries;
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingCountries = false);
  }
}
